import { render, staticRenderFns } from "./airports.vue?vue&type=template&id=5e2e26a6&scoped=true&"
import script from "./airports.vue?vue&type=script&lang=js&"
export * from "./airports.vue?vue&type=script&lang=js&"
import style0 from "./airports.vue?vue&type=style&index=0&id=5e2e26a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e26a6",
  null
  
)

export default component.exports